import styled from "styled-components";
import DefaultContainer from "./DefaultContainer";

const Container = styled.footer`
  background-color: #f8f9fa;
  padding: 60px 0;
  color: #6c757d;
    display: flex;
    justify-content: center;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const BrandName = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #343a40;
`;

const BrandTagline = styled.div`
  font-size: 14px;
  line-height: 1.6;
`;

const LinksSection = styled.div`
  display: flex;
    justify-content: space-between;
  gap: 20px;
`;

const FooterLink = styled.a`
  color: #6c757d;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;

  &:hover {
    color: #007bff;
  }
`;

const BottomSection = styled.div`
  padding-top: 30px;
  border-top: 1px solid #dee2e6;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Informations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Footer = () => {
  return (
    <Container>
      <DefaultContainer>
        <Contents>
          <div>
            <BrandName>Following Moments</BrandName>
            <BrandTagline>
              장소를 따라, 순간을 기록하다
            </BrandTagline>
          </div>

          <LinksSection>
            <FooterLink href="https://lone.followingmoments.com" target="_blank" rel="noopener noreferrer">
              LoNe
            </FooterLink>
            <FooterLink href="https://lone.followingmoments.com/terms/privacy-policy" target='_blank' rel='noopener noreferrer'>
              개인정보처리방침
            </FooterLink>
            <FooterLink href="mailto:contact@followingmoments.com">
              이메일
            </FooterLink>
          </LinksSection>

          <BottomSection>
            <Informations>
              <div>사업자번호: 624-01-03208 | 통신판매업: 2024-용인기흥-0606</div>
              <div>주소: 경기도 용인시 기흥구 강남서로 9</div>
            </Informations>
            <div>
              © 2025 Following Moments. All rights reserved.
            </div>
          </BottomSection>
        </Contents>
      </DefaultContainer>
    </Container>
  );
};

export default Footer;
